import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { RoleService } from 'src/app/service/auth/role.service';
import { RolePermissionService } from 'src/app/service/auth/role-permission.service';

@Component({
    selector: 'app-role-permission',
    templateUrl: './role-permission.component.html',
    styles: []
})
export class RolePermissionComponent implements OnInit {
    constructor(
        private toastr: ToastrService,
        private roleService: RoleService,
        private rolePermissionService: RolePermissionService,
    ) { }

    menu: string = "AspNetRolePermission";

    roleId: string = "";
    roles: any[] = [];
    rolePermissions: any = {};
    menus: any[] = [];
    menuRaws: any[] = [];
    controls: any[] = [];

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.loadDataRole();
    }

    loadDataRole() {
        this.roleService.getListRole().subscribe(
            res => {
                this.roles = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onChangeRole() {
        this.loadDataRolePermission();
    }

    loadDataRolePermission() {
        if (this.roleId && this.roleId.length > 0) {
            this.menus = [];
            this.menuRaws = [];
            this.controls = [];

            this.rolePermissionService.getListRolePermission(this.roleId).subscribe(
                res => {
                    this.rolePermissions = <any>res;

                    for (var i = 0; i < this.rolePermissions.roleClaims.length; i++) {
                        var item = this.rolePermissions.roleClaims[i];
                        let c = item.control;
                        if (!this.controls.find(x => x.guid == c.guid)) {
                            this.controls.push(c);
                        }

                        let m = item.menu;
                        if (!this.menuRaws.find(x => x.guid == m.guid)) {
                            this.menuRaws.push(m);
                        }
                    }
                    this.controls.sort((a, b) => b.name.localeCompare(a.name));

                    this.menuRaws.sort((a, b) => a['sort'] - b['sort']);
                    for (const menuParent of this.menuRaws.filter(x => !x.guidParent)) {
                        menuParent.Childs = this.menuRaws.filter((x) => x.guidParent == menuParent.guid);

                        for (const menuChild of menuParent.Childs) {
                            menuChild.ChildChilds = this.menuRaws.filter((x) => x.guidParent == menuChild.guid);
                        }

                        this.menus.push(menuParent);
                    }
                },
                err => {
                    this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                },
            );
        }
        else
            this.rolePermissions = {};
    }

    onRefresh() {
        this.loadDataRolePermission();
    }

    onSave() {
        document.getElementById('page-loader-data').style.display = "block";
        for (var i = 0; i < this.rolePermissions.roleClaims.length; i++) {
            var item = this.rolePermissions.roleClaims[i];
            var inputCheck = <any>document.getElementById(item.value);

            item.selected = inputCheck.checked;
        }

        this.rolePermissionService.updateRolePermission(this.rolePermissions).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.loadDataRolePermission();
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    showCheckbox(menu: any, control: any) {
        return this.rolePermissions.roleClaims.find(x => x.value == "Permissions." + menu.code + "." + control.code);
    }

    checkedCheckbox(menu: any, control: any) {
        let code = "Permissions." + menu.code + "." + control.code;
        if (this.rolePermissions.roleClaims.find(x => x.value == code).selected) {
            var inputCheck = <any>document.getElementById(code);

            if (inputCheck) {
                inputCheck.checked = true;
            }

            return "checked";
        };

        return "";
    }
}